import { render, staticRenderFns } from "./ActionRelationshipsCard.vue?vue&type=template&id=1ca9b6bd&scoped=true&"
import script from "./ActionRelationshipsCard.vue?vue&type=script&lang=js&"
export * from "./ActionRelationshipsCard.vue?vue&type=script&lang=js&"
import style0 from "./ActionRelationshipsCard.vue?vue&type=style&index=0&id=1ca9b6bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9b6bd",
  null
  
)

export default component.exports